import { PrimitiveType } from "@buildwithflux/models";
import { Clipper, JoinType } from "../../../clipper";
import { mat3 } from "../../../common";
import { approxFittingPolygon } from "./approxFittingPolygon";
const clipperSettings = {
    joinType: JoinType.Round,
};
/** Compared to approxFittingPolygon, this function actually returns a proper precise shape with holes */
export function primitiveToClipper(primitive, segments) {
    switch (primitive.type) {
        case PrimitiveType.Circle:
        case PrimitiveType.Oblong:
        case PrimitiveType.Rectangle:
        case PrimitiveType.RoundedRectangle:
        case PrimitiveType.Line:
        case PrimitiveType.LineArc:
        case PrimitiveType.ApproxPolygon:
            // TODO: for the ApproxPolygon case we are ignoring the holes, but it seems like we do that everywhere else too
            return Clipper.shape([approxFittingPolygon(primitive, segments, false)]);
        case PrimitiveType.Expansion:
            return transformClipperPolygon(primitiveToClipper(primitive.primitive, segments).offset(primitive.expansion, clipperSettings), primitive.transform);
        case PrimitiveType.Union:
            return transformClipperPolygon(primitiveToClipper(primitive.primitiveA, segments).union([
                primitiveToClipper(primitive.primitiveB, segments),
            ]), primitive.transform);
        case PrimitiveType.Difference:
            return transformClipperPolygon(primitiveToClipper(primitive.primitiveA, segments).subtract([
                primitiveToClipper(primitive.primitiveB, segments),
            ]), primitive.transform);
    }
}
function transformClipperPolygon(shape, transform) {
    return shape.transform3Shape(mat3.toThreeMatrix3(transform));
}
//# sourceMappingURL=primitiveToClipper.js.map